import { initMessageGearsForms } from '../message-gears/services/message-gears-provider';

document.addEventListener('DOMContentLoaded', () => {

    // https://wavesaudio.atlassian.net/browse/DSWEB-1837
    // https://dev13.waves.com/newsletter
    initMessageGearsForms();
});